(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCategoryDeleteController',RptCategoryDeleteController);

    RptCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptCategory'];

    function RptCategoryDeleteController($uibModalInstance, entity, RptCategory) {
        var vm = this;

        vm.rptCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
